<div class="learn-wrap">
    <app-header></app-header>
    <div class="learn-section-wrap d-flex justify-content-center flex-column">
        <h1 class="">Speech Data Collection <br /> Platform</h1>
        <p class="accent-detail">Advancing speech AI research, One Voice at a time
        </p>
        <section class="why-sect mb-5">
            <h3>Why SautiDB?</h3>
            <section class="row">
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">Having SautiDB can help us translate content in Foreign English to local English accents and
                    this can be used to improve online learning educational experience</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">With SautiDB, we can create a database of Nigerian voices that can be used to improve Artificial Intelligence research</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">Your local language could be more respresented and services could be localized if you contribute</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">Help us collect samples of different accented voices across Nigeria by
                    donating your voice sample.</p>
                </div>
            </section>
        </section>
        <!-- <section class="why-sect mb-5">
            <h3>Why should I donate?</h3>
            <section class="row">
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">We believe your voice carries your identity and lending it will improve speech AI one voice at a time.
                    </p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4">
                    <img src="../../assets/svg/count_svg.svg" alt="list icon" class="mr-3">
                    <p class="">SautiDB aims to curate a collection of large open source dataset to help advance speech AI research and reduce inequality in this field and other related research fields.</p>
                </div>
            </section>
        </section> -->
        <section class="why-sect mb-5">
            <h3>How does it work?</h3>
            <section class="row">
                <div class="d-flex col-lg-6 col-sm-12 mb-4 align-items-center">
                    <img src="../../assets/svg/sautiIcon.svg" alt="list icon" class="mr-3">
                    <p class="mb-0">Record displayed sentence</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4 align-items-center">
                    <img src="../../assets/svg/sautiIcon.svg" alt="list icon" class="mr-3">
                    <p class="mb-0">Pause or play at your convenience</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4 align-items-center">
                    <img src="../../assets/svg/sautiIcon.svg" alt="list icon" class="mr-3">
                    <p class="mb-0">Stop recording once you finish the sentence</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4 align-items-center">
                    <img src="../../assets/svg/sautiIcon.svg" alt="list icon" class="mr-3">
                    <p class="mb-0">Upload the sentence</p>
                </div>
                <div class="d-flex col-lg-6 col-sm-12 mb-4 align-items-center">
                    <img src="../../assets/svg/sautiIcon.svg" alt="list icon" class="mr-3">
                    <p class="mb-0">Record your next sentence</p>
                </div>
            </section>
        </section>
        <div class="d-flex justify-content-center">
            <a href="/home" class="get-started d-flex align-items-center justify-content-center"> Get started</a>
        </div>
    </div>
</div>